import React, { createContext, useState, useContext, useCallback } from "react";
import { SuccessModal } from "../components/common/SuccessModal";

// --- 1. The UI Component for the Modal ---
// This is a presentational component that will be displayed when the modal is active.

// --- 2. The Context and Provider Logic ---
const ModalContext = createContext();

export const ModalProvider = ({ children }) => {
  const [modalState, setModalState] = useState({
    isOpen: false,
    title: "",
    message: "",
    ctaButtonText: "",
  });

  const showModal = useCallback((title, message, ctaButtonText) => {
    setModalState({ isOpen: true, title, message, ctaButtonText });
  }, []);

  const hideModal = useCallback(() => {
    setModalState({ isOpen: false, title: "", message: "" });
  }, []);

  return (
    <ModalContext.Provider value={{ showModal }}>
      {children}
      {modalState.isOpen && (
        <SuccessModal
          title={modalState.title}
          message={modalState.message}
          ctaBtnText={modalState.ctaButtonText}
          onClose={hideModal}
        />
      )}
    </ModalContext.Provider>
  );
};

// --- 3. The Custom Hook ---
// This makes it easy to access the showModal function from any component.
export const useModal = () => {
  return useContext(ModalContext);
};
